import { render, staticRenderFns } from "./PDPSectionTabs.vue?vue&type=template&id=f3eae050&scoped=true&"
import script from "./PDPSectionTabs.vue?vue&type=script&lang=js&"
export * from "./PDPSectionTabs.vue?vue&type=script&lang=js&"
import style0 from "./PDPSectionTabs.vue?vue&type=style&index=0&id=f3eae050&prod&lang=css&"
import style1 from "./PDPSectionTabs.vue?vue&type=style&index=1&id=f3eae050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eae050",
  null
  
)

export default component.exports